import React from 'react';
import { Text, View } from '../../../../../components/Common/react-native-components';
import { StyleSheet } from 'react-native';

const Breadcrumb = ({ currentLevel, onLevelClick }) => {
  const levels = Object.entries(currentLevel || {}).filter(([key, value]) => value && String(value).trim() !== '');

  return (
    <View style={styles.container}>
      {levels.map(([key, label], index) => (
        <View key={key} style={styles.levelWrapper}>
          <Text
            style={index === levels.length - 1 ? styles.textActive : styles.textClickable}
            onPress={() => {
              if (index < levels.length - 1) {
                const newLevel = {};
                levels.slice(0, index + 1).forEach(([k, v]) => {
                  newLevel[k] = v;
                });
                onLevelClick(key, newLevel);
              }
            }}>
            {label}
          </Text>
          {index < levels.length - 1 && <Text style={styles.separator}>&gt;</Text>}
        </View>
      ))}
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 16
  },
  levelWrapper: {
    flexDirection: 'row',
    alignItems: 'center'
  },
  textClickable: {
    color: '#266ec9',
    textDecorationLine: 'underline',
    fontWeight: '400'
  },
  textActive: {
    color: '#000',
    fontWeight: '600'
  },
  separator: {
    marginHorizontal: 8,
    color: '#999'
  }
});

export default Breadcrumb;
